import { CgProfile } from "react-icons/cg";
import { FaCog, FaRegTrashAlt } from "react-icons/fa";
import { MdAppSettingsAlt } from "react-icons/md";
import { TbPlugConnectedX } from "react-icons/tb";
import { FaMoneyBillTrendUp } from "react-icons/fa6";
import { MdBusiness } from 'react-icons/md'

export const getProfilePageSideMenuItems = (role) => {
    const items = [
        {
            key: '1',
            icon: <CgProfile className="me-2" />,
            label: 'My Profile',
        },
        ...(role !== "user" ? [{
            key: '2',
            icon: <MdBusiness className="me-2" />,
            label: 'Company Info',
        }] : []),
        {
            key: '3',
            icon: <FaRegTrashAlt className="me-2" />,
            label: 'Deleted Threads',
        },
        {
            key: '4',
            icon: <FaMoneyBillTrendUp className="me-2" />,
            label: 'Personal Usage Reports',
        },
        {
            key: '5',
            icon: <MdAppSettingsAlt className="me-2" />,
            label: 'Customize Chat',
        },
        {
            key: '6',
            icon: <FaMoneyBillTrendUp className="me-2" />,
            label: 'AI Model Configuration',
        },
        {
            key: '7',
            icon: <FaCog className="me-2" />,
            label: 'Organization Settings',
        },
        {
            key: '8',
            icon: <TbPlugConnectedX className="me-2" />,
            label: 'Connected Apps',
        }
    ];

    return items;
}; 